export default __webpack_public_path__ + "static/media/llinois.4556bdae.jpg";